export const singleDtFormat = (args: string) => {
  return (
    args.substring(0, 4) +
    '/' +
    args.substring(4, 6) +
    '/' +
    args.substring(6, 8)
  )
}

export const arrayDtFormat = (args: string[]) => {
  return args.map(
    (dt: string) =>
      dt.substring(0, 4) + '/' + dt.substring(4, 6) + '/' + dt.substring(6, 8),
  )
}
